export default "__VITE_ASSET__yEsA51eT__"